import React from "react";
import { Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";
import { useSelector } from "react-redux";

function Footer() {
  const langue = useSelector((state) => state.langue.value);

  return (
    <footer className="bg-gray-300 text-black py-8">
      <hr className="mb-4" />

      <div className="max-w-6xl flex flex-row text-xs justify-around mx-auto px-6 gap-8">
        {/* Colonne 1 : Navigation */}
        <div>
          <h3 className="text-xl font-bold mb-3">
            {langue === "fr" ? "Navigation" : "التنقل"}
          </h3>
          <ul className="space-y-2">
            <li>
              <a href="/" className="hover:text-green-500">
                {langue === "fr" ? "Accueil" : "الرئيسية"}
              </a>
            </li>
            <li>
              <a href="/services" className="hover:text-green-500">
                {langue === "fr" ? "Services" : "الخدمات"}
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:text-green-500">
                {langue === "fr" ? "Contact" : "اتصل"}
              </a>
            </li>
            <li>
              <a href="/about" className="hover:text-green-500">
                {langue === "fr" ? "À propos" : "عن الشركة"}
              </a>
            </li>
          </ul>
        </div>

        {/* Colonne 2 : Contact */}
        <div className="space-y-2">
          <h3 className="text-xl font-bold mb-3">
            {langue === "fr" ? "Contact" : "اتصل بنا"}
          </h3>
          <p className="flex items-center gap-2">
            <Mail size={18} /> gramdane8@gmail.com
          </p>
          <p className="flex items-center gap-2">
            <Phone size={18} /> +213 671732455
          </p>
          <p className="flex items-center gap-2">
            <MapPin size={18} /> {langue === "fr" ? "Alger, Algérie" : "الجزائر، الجزائر"}
          </p>
        </div>

        {/* Colonne 3 : Réseaux sociaux */}
      </div>

      <div className="flex space-x-4 justify-center mt-2">
        <a
          href="https://www.facebook.com/Estantar?rdid=3UFMbm3XZiC23XQq&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F18zuQER7D6%2F#"
          className="text-blue-600 hover:text-blue-800"
        >
          <Facebook size={24} />
        </a>
        <a
          href="https://www.instagram.com/est_epices_antar?igsh=b3k2cHplZmUzbHp5"
          className="text-pink-500 hover:text-pink-700"
        >
          <Instagram size={24} />
        </a>
      </div>

      {/* Ligne de séparation */}
      <hr className="border-gray-700 my-6 max-w-6xl mx-auto" />

      {/* Copyright */}
      <p className="text-center text-gray-400 text-sm">
        {langue === "fr"
          ? `© ${new Date().getFullYear()} Antar - Tous droits réservés.`
          : `© ${new Date().getFullYear()} Antar - جميع الحقوق محفوظة.`}
      </p>
    </footer>
  );
}

export default Footer;
